/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");

require('components/base/input-box/input-box');
require('components/base/checkbox/checkbox');
require('components/base/form-area/form-area');
require('components/base/drop-menu/drop-menu');
require('components/base/upload/upload')
require('components/base/tab/tab');
require('components/base/pop/tip');
require('components/common/drop-menu-input/drop-menu-input')
require('components/common/date-time/date-time')

require('./add-list-topic.scss');

const tip = require('components/base/pop/tip');
const template = require('./add-list-topic.tpl');
const store = require('appVuex/store');
const ajaxHttp = require('appUtil/ajaxHttp.js');
const configPushMixin = require('../../mixin')

const { apiPath } = require('appService/api');
const { tab: tabEvent } = require('components/config/event.json');
const { getTopicList: topicList } = require('appVuex/getter/common')

const addListTopic = {
  name: "add-list-topic",

  template,

  mixins: [configPushMixin],

  data() {
    return {
      uploadImg: apiPath.common.uploadImg,
      topicUrl: apiPath.common.topic,
      detailData: {
        public: {},
        topics: [{}]
      },
      otherContentDisplay: false,
      tabItems: [{
        value: 1,
        text: '新增独推话题'
      }, {
        value: 2,
        text: '新增多个话题'
      }],
      isEdit: false
    }
  },

  store,

  computed: {
    linkInput() {
      return this.detailData.adType === 0 ? this.detailData.link : ''
    },

    isEdit() {
      return !!this.$route.params.id
    }
  },

  events: {
    [tabEvent.change]({item}) {
      if (item.value === 1) {
        this.detailData.topics = [{}]
      } else {
        this.detailData.topics = [{}, {}, {}]
      }
    }
  },

  methods: {
    _init() {
      if (this.isEdit) {
        // 编辑状态
        ajaxHttp(apiPath.configPush.listTopic.detail, {
          data: {
            id: this.$route.params.id
          }
        }).then((rtn) => {
          this.detailData = rtn.data
        }).catch((rtn) => {
          tip(rtn.message)
        })
      }
    },

    _singleCheckbox(val) {
      return val === 1 ? [val] : []
    },

    processDropItems(items) {
      return items.all
    },

    beforeSubmit(query, vm) {
      var queryOpt = {
        topics: [],
        public: {}
      }
      var queryInfo = vm.queryInfo

      if (!Array.isArray(query.topicId)) {
        query.orderNum = [query.orderNum]
        query.topicId = [query.topicId]
        query.redirectType = [query.redirectType]
        queryInfo.topicId = [queryInfo.topicId]
      }

      query.topicId.forEach((item, index) => {
        let pushData = {
          redirectType: query.redirectType[index],
          id: item
        }

        Object.assign(pushData, {
          title: queryInfo.topicId[index].text,
          orderNum: query.orderNum && query.orderNum[index] || 0
        })

        queryOpt.topics.push(pushData)
      })

      // 检查有无重复 topic
      let topicOpt = queryOpt.topics
      for (let i = 0, len = topicOpt.length; i < len; i++) {
        for (let j = i + 1; j < len; j++) {
          if (topicOpt[i].id === topicOpt[j].id) {

            tip('有重复话题，请修改！')
            return false
          }
        }
      }

      queryOpt.public = {
        pushRange: query.pushRange,
        pushUserId: query.pushUserId,
        pushUserIdTail: query.pushUserIdTail,
        pushTime: query.pushTime
      }

      queryOpt.id = query.id

      vm.queryOpt = queryOpt

      this.$refs.submit.switchBtnLoading('show')
    },

    submit() {
      var $refs = this.$refs

      if (this.isEdit) {
        $refs.formArea.setAction(apiPath.configPush.listTopic.edit).submit()
      } else {
        $refs.formArea.setAction(apiPath.configPush.listTopic.add).submit()
      }
    },

    submitSuccess(rtn) {
      const self = this

      if (rtn.code === 0) {
        tip(`${this.isEdit ? '保存' : '新增'}成功`, {
          cb() {
            self.$route.router.go({
              path: '/page/configPush/listTopic'
            })
          }
        })
      } else {
        tip(rtn.error)
      }

      this.$refs.submit.switchBtnLoading('hide')
    },

    processDropItems(item) {
      item.unshift({
        value: -1,
        text: '请选择'
      })

      return item
    }
  },

  ready() {
    this._init();
  }
}

module.exports = addListTopic;



// WEBPACK FOOTER //
// ./src/appBackend/components/page/configPush/list-topic/add-list-topic/add-list-topic.js